<!-- 热门模拟交易 -->
<template>
  <div class="Rmmnjy" :class="$route.query.themeStyleVs == 2 ? 'black_theme' : 'white_theme'">
    <div class="title_t">
      <p>热门模拟交易</p>
      <p @click="mnMore">更多<van-icon name="arrow" /></p>
    </div>
    <div class="box">
      <ul v-if="mnList.length > 0 && mnQuery" class="list">
        <div v-for="(item, index) in mnList" @click="goMnDetail(item)" class="top_box">
          <li v-if="index < 5" :key="index">
            <!-- :style="{ gridRow: (index % 2) + 1, gridColumn: Math.floor(index / 2) + 1 }" -->

            <div class="tit one-txt-cut">
              <span class="tit-text one-txt-cut" >{{ item.ts_name }}</span>
              <span class="pay_icon" v-if="item.review_status == '1'" > <img :src="payImg" alt="" srcset=""> </span>
            </div>

            <div class="rm_top">
              <div class="main">
                <span class="name">创建后收益</span>
                <span :class="[judgeColor(item.lastProfit.totalRisk)]">{{
                  toFixedNum(item.lastProfit.totalRisk * 100, 2, '%')
                }}</span>
              </div>
              <div class="main">
                <span class="name">今日收益</span>
                <span :class="[judgeColor(item.lastProfit.todayRisk)]">{{
                  toFixedNum(item.lastProfit.todayRisk * 100, 2, '%')
                }}</span>
              </div>
              <div class="main">
                <span class="name">最大回撤</span>
                <span class="num">{{
                  toFixedNum(item.lastProfit.maxRetreatRate * 100, 2, '%')
                }}</span>
              </div>
            </div>

            <div class="chart_box" :id="'chartLineBox' + index"></div>
            <div class="fod_box">
              <div class="left">自{{ convertTime(item.lineData.xData[0]) }}</div>
              <div class="right">
                <span>收益</span>
                <span>沪深</span>
              </div>
            </div>
          </li>
        </div>
      </ul>

      <ul v-if="mnList.length > 0 && mnQuery" class="list">
        <div v-for="(item, index) in mnList" @click="goMnDetail(item)" class="bottom_box">
          <li v-if="index > 4" :key="index">
            <!-- :style="{ gridRow: (index % 2) + 1, gridColumn: Math.floor(index / 2) + 1 }" -->

            <div class="tit one-txt-cut">
              <span class="tit-text one-txt-cut" >{{ item.ts_name }}</span>
              <span class="pay_icon" v-if="item.review_status == '1'"  > <img :src="payImg" alt="" srcset=""> </span>
            </div>

            <div class="rm_top">
              <div class="main">
                <span class="name">创建后收益</span>
                <span :class="[judgeColor(item.lastProfit.totalRisk)]">{{
                  toFixedNum(item.lastProfit.totalRisk * 100, 2, '%')
                }}</span>
              </div>
              <div class="main">
                <span class="name">今日收益</span>
                <span :class="[judgeColor(item.lastProfit.todayRisk)]">{{
                  toFixedNum(item.lastProfit.todayRisk * 100, 2, '%')
                }}</span>
              </div>
              <div class="main">
                <span class="name">最大回撤</span>
                <span class="num">{{
                  toFixedNum(item.lastProfit.maxRetreatRate * 100, 2, '%')
                }}</span>
              </div>
            </div>

            <div class="chart_box" :id="'chartLineBox' + index"></div>
            <div class="fod_box">
              <div class="left">自{{ convertTime(item.lineData.xData[0]) }}</div>
              <div class="right">
                <span>收益</span>
                <span>沪深</span>
              </div>
            </div>
          </li>
        </div>
      </ul>
    </div>
  </div>
</template>

<script>
import { getHotMokpanel } from '@/api/index.js';
import { judgeColor, toFixedNum,compareVersions } from '@/utils/format';
import mixin from '@/mixins/index.js';
export default {
  name: 'Rmmnjy',
  mixins: [mixin],
  props: [],

  data() {
    return {
      payImg: require('../../assets/image/pay-icon.png'),
      mnList: [],
      mnQuery: false,
      chartList: [],
      isVip: false
    };
  },
  filters: {},
  created() {},
  watch: {
    '$store.state.isVip': {
      handler(newValue) {
        this.isVip = newValue;
      },
      immediate: true // 立即执行一次
    }
  },
  async mounted() {
    this.getMokpanel();
  },
  methods: {
    judgeColor,
    toFixedNum,
    compareVersions,
    // 获取热门模拟交易数据
    getMokpanel: function () {
      let _this = this;
      let obj = {
        limit: 10,
        page: 1,
        type: _this.mnTabId
      };
      getHotMokpanel(obj)
        .then((res) => {
          _this.$toast.clear();
          if (res.err === 200) {
            _this.mnList = res.data;

            _this.$nextTick(function () {
              if (res.data.length < 10) {
                //是否已加载完成，加载完成后不再触发load事件
                _this.finished = true;
              } else {
                _this.loading = false;
                _this.finished = false;
              }
              _this.chartFn();
            });
          } else {
            _this.finished = true;
            _this.loading = true;
            _this.finishedText = '';
          }
          _this.mnQuery = true;
        })
        .catch(() => {
          _this.finished = true;
          _this.loading = true;
          _this.finishedText = '';
          _this.$toast.clear();
        });
    },

    resizeHandler() {
      this.chartList.forEach((item) => {
        if (item) {
          item.resize();
        }
      });
    },

    // 创建图表
    chartFn: function () {
      let _this = this;
      let dataList = _this.mnList;
      dataList.forEach((item, index) => {
        if (!_this.chartList[index]) {
          let chartDom = document.getElementById('chartLineBox' + index);
          _this.chartList[index] = _this.$echarts.init(chartDom);
          window.addEventListener('resize', _this.resizeHandler);
        }
        let xData = item.lineData.xData;
        let dataSy = item.lineData.profitRate;
        let dataHs = item.lineData.hs300Rate;
        let option = {
          color: ['#286DF7', '#FF770C'],
          grid: {
            left: 0,
            top: 0,
            right: 0,
            bottom: 0
          },
          xAxis: {
            show: false,
            type: 'category',
            data: xData
          },
          yAxis: {
            show: false,
            type: 'value'
          },
          series: [
            {
              symbol: 'none',
              data: dataSy,
              type: 'line',
              smooth: true,
              itemStyle: {
                lineStyle: {
                  color: '#000000' //改变折线颜色
                }
              },
              lineStyle: {
                width: 1 // 修改折线的粗细
              }
            },
            {
              symbol: 'none',
              data: dataHs,
              type: 'line',
              smooth: true,
              itemStyle: {
                lineStyle: {
                  color: '#FF770C' //改变折线颜色
                }
              },
              lineStyle: {
                width: 0.5 // 修改折线的粗细
              },
              markLine: {
                symbol: ['none', 'none'], // none为标线两端的样式为无，可更改
                data: [
                  {
                    silent: false,
                    yAxis: 0, // 表现自定义的位置，可赋值
                    label: {
                      position: 'end', // 表现内容展示的位置
                      formatter: '中文路均值', // 标线展示的内容
                      color: '#8C8C8C', // 展示内容颜色
                      show: false
                    },
                    lineStyle: {
                      type: 'dashed',
                      color:
                        _this.themeStyleVs === 2
                          ? 'rgba(255, 255, 255, 0.1)'
                          : 'rgba(0, 0, 0, 0.2)',
                      width: 1
                    } // 样式： 线型、颜色、线宽
                  }
                ]
              }
            }
          ]
        };
        option && _this.chartList[index].setOption(option);
      });
    },

    // 跳转模拟详情
    goMnDetail: function (item) {
      // 判断是否是 vip
      // if(this.isVip == false && compareVersions(this.$route.query.version , 9.92)) {
      //   let appJson = {
      //     DialogType: "basic",
      //   };
      //   DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc(
      //     'factorTYPerDialog',
      //     JSON.stringify(appJson),
      //     ''
      //   );
      // } else if (this.isVip == false && compareVersions(this.$route.query.version , 9.71)) {
      //   // 如果不是VIP用户,弹出VIP提示
      //   let appJson = {
      //     channel: 'yinzi',
      //     dzhadid: '0704'
      //   };
      //   DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc(
      //     'factorNoVipPerDialog',
      //     JSON.stringify(appJson),
      //     ''
      //   );
      // } else {
      //   location.href = '/mnDetail?DZHSPECIAL=4325641&type=hot&zj_id=' + item.zj_id;
      // }
      location.href = '/mnDetail?DZHSPECIAL=4325641&type=hot&zj_id=' + item.zj_id;
    },

    // 模拟更多
    mnMore: function () {
      location.href = '/hot?DZHSPECIAL=4325641&navId=1';
    }
  },
  beforeDestroy() {}
};
</script>
<style lang="less" scoped>
.Rmmnjy {
  padding: 0 0 0 16px;
  margin-top: 30px;
  .title_t {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 9px;
    padding-right: 16px;
    p {
      color: #222;
      &:first-child {
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
      }
      &:last-child {
        border-radius: 10px;
        background: #f7f8fa;
        padding: 3px 6px 3px 10px;
        font-size: 10px;
        font-weight: 500;
      }
    }
  }
  .box {
    overflow-x: auto;
  }
  .list {
    // display: -ms-grid; /* 兼容旧版本的 IE 浏览器 */
    // display: grid;
    // -ms-grid-columns: 1fr 10px 1fr 10px 1fr 10px 1fr 10px 1fr; /* 旧版本 IE 的列定义 */
    // grid-template-columns: repeat(5, 1fr);
    // // gap: 10px;
    display: flex;
    // .top_box,
    // .bottom_box {
    // }
    li {
      // flex: 0 0 20%;
      box-sizing: border-box;
      width: 155px;
      height: 200px;
      padding: 12px;
      border-radius: 8px;
      border: 1px solid #e5e5e5;
      background: #f9fafb url('../../assets/image/mnjy2x.png') no-repeat top right;
      background-size: 164px 55px;
      margin-right: 10px; /* 添加间隔 */
      margin-bottom: 10px; /* 添加间隔 */
      :last-child {
        margin-right: 0;
      }
      &:nth-child(9) {
        margin-right: 16px;
      }
      &:nth-child(10) {
        margin-right: 16px;
      }
      .tit {
        // font-size: 16px;
        // color: #555;
        // font-weight: 600;
        margin-bottom: 7px;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-content: center;
        justify-content: space-between;
        align-items: center;
        .tit-text{
          font-size: 16px;
          color: #555;
          font-weight: 600;
          // border: 1px solid red;
          max-width: 95px;
        }
        .pay_icon{
              width: 32px;
              height: 17px;
              // border: 1px solid red;
            }
      }
      .rm_top {
        border-bottom: 1px solid #e5e5e5;
        padding-bottom: 4px;
        margin-bottom: 4px;
        .main {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 5px;

          span {
            font-size: 12px;

            &:first-child {
              color: #999;
              margin-right: 12px;
            }
            &:last-child {
              color: #373a4d;
              font-weight: 500;
            }
          }
        }
      }

      .chart_box {
        width: 100%;
        height: 52px;
      }
      .fod_box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 11px;
        color: #666;
        margin-top: 4px;
        .right {
          span {
            &:first-child {
              color: #286df7;
              margin-right: 10px;
            }
            &:last-child {
              color: #ff770c;
            }
          }
        }
      }
    }

  }
}
</style>

<!-- 黑色主题 -->
<style lang="less" scoped>
.black_theme {
  .title_t {
    p {
      &:first-child {
        color: #e4e9fe;
      }
      &:last-child {
        background: #1d202d;
        color: #e4e9fe;
      }
    }
  }
  .list {
    li {
      border: 1px solid #353a50;
      background: #272935 url('../../assets/image/mnjy2x.png') no-repeat top right;
      background-size: 164px 55px;
      .tit {
        color: #aab9d1;
      }
      .rm_top {
        border-bottom: 1px solid #353a50;
        .main {
          .name {
            color: #6b7687 !important;
          }
          .num {
            color: #6b7687 !important;
          }
        }
      }
      .fod_box {
        .left {
          color: #6b7687;
        }
      }
      .tit {
        .tit-text {
          color:#aab9d1 !important;
        }
      }
    }
  }
}
</style>
